import React from 'react'
import { Card } from "react-bootstrap"
import { FaPhone, FaMapMarkerAlt, FaCalendar, FaCommentAlt, FaStar } from "react-icons/fa"
import { reactLocalStorage } from 'reactjs-localstorage';
import Const from '../../../util/Constants';
import Util from '../../../util/Util';
import DB from '../../../util/LocalDB';
import CallAPI from '../../../api/CallAPI';
import MeetingAPI from '../../../api/MeetingAPI';
import ApiUiController from '../../../controller/ApiUiController';
import Display from '../../../util/Display';

class TimelineTab extends React.Component {
  constructor(props) {
    super(props);

    this.callModel = reactLocalStorage.getObject(Const.Model).call;
    this.meetModel = reactLocalStorage.getObject(Const.Model).meeting;

     this.state = {
      inApiCall: true,
      timeline: []
    };
    this.timeline = [];

    const user = parseInt(
      reactLocalStorage.getObject(Const.LoggedInUser).user_id
    );
    this.User = Const.Opt + user + Const.Opt;

    // permissions
    this.CallView = Util.isAllow(this.callModel.permission, Const.PermView);
    this.MeetView = Util.isAllow(this.meetModel.permission, Const.PermView);

    this.CallRestrict = Util.isAllow(
      this.callModel.permission,
      Const.PermInnerListRestrict
    );
    this.MeetRestrict = Util.isAllow(
      this.meetModel.permission,
      Const.PermInnerListRestrict
    );

    this.callActions = DB.getActions(Const.Call);
    this.meetActions = DB.getActions(Const.Meeting);
  }
  
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.id !== this.props.id) {
      this.setState({ inApiCall: true, timeline: [] });
      this.loadTimeline(nextProps.id);
    }
  }

  componentDidMount() {
    this.loadTimeline(this.props.id);
  }

  loadTimeline = (id) => {
    this.timeline = [];

    if (this.CallView) {
      CallAPI.getInnerList(
        this.props.type,
        id,
        this.onCallReceived,
        this.onError,
        this.CallRestrict,
        this.User
      );
    } else {
      this.loadMeetings(id);
    }
  };

  loadMeetings = (id) => {
    if (!this.MeetView) {
      this.finalize();
      return;
    }

    MeetingAPI.getInnerList(
      this.props.type,
      id,
      this.onMeetingReceived,
      this.onError,
      this.MeetRestrict,
      this.User
    );
  };

  onCallReceived = (res) => {
    const calls = res.data.map(c => ({
      ...c,
      _type: 'call',
      _date: c.date_time
    }));

    this.timeline = calls;
    this.loadMeetings(this.props.id);
  };

  onMeetingReceived = (res) => {
    const meetings = res.data.map(m => ({
      ...m,
      _type: 'meeting',
      _date: m.date_time
    }));

    this.timeline = [...this.timeline, ...meetings];
    this.finalize();
  };

  finalize = () => {
    const timeline = this.timeline.sort(
      (a, b) => new Date(b._date) - new Date(a._date)
    );

    this.setState({
      inApiCall: false,
      timeline
    });
  };
  
  onError = () => {
    this.setState({ inApiCall: false });
  };


  render() {

    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <div style={{ marginTop: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
            <h4 style={{ fontSize: '18px', fontWeight: '600', color: '#111827' }}>Activity Timeline</h4>
            <span style={{ fontSize: '14px', color: '#6b7280' }}>{this.timeline.length} Activities</span>
          </div>

          <div style={{ position: 'relative' }}>
            

            <div style={{ marginTop: '16px' }}>
              {this.timeline.length <= 0 ? 
                <p>No calls and meetings</p>
               : this.timeline.map((activity, index) => {
                const model = activity?._type == "call" ? this.callModel: this.meetModel;
                return <div key={index} style={{ position: 'relative', display: 'flex', gap: '16px', marginBottom: '16px' }}>
                  <div style={{
                    position: 'relative',
                    zIndex: 10,
                    flexShrink: 0,
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                    background: activity._type === "call" 
                      ? 'linear-gradient(135deg, #4ade80, #16a34a)' 
                      : 'linear-gradient(135deg, #60a5fa, #3b82f6)'
                  }}>
                    {activity._type === "call" ? (
                      <FaPhone size={20} style={{ color: 'white' }} />
                    ) : (
                      <FaMapMarkerAlt size={20} style={{ color: 'white' }} />
                    )}
                  </div>

                  <Card style={{ 
                    flex: 1, 
                    backgroundColor: 'white', 
                    border: '1px solid #e5e7eb', 
                    borderRadius: '8px', 
                    padding: '16px',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '12px' }}>
                      <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                          {/* Badge for activity type */}
                          <span style={{
                            fontSize: '12px',
                            padding: '4px 8px',
                            borderRadius: '9999px',
                            fontWeight: '500',
                            backgroundColor: activity._type === "call" ? '#dcfce7' : '#dbeafe',
                            color: activity._type === "call" ? '#166534' : '#1e40af',
                            textTransform: 'uppercase'
                          }}>
                            {activity._type === "call" ? "Phone Call" : "Site Visit"}
                          </span>
                          
                          {/* Duration badge for calls */}
                          {activity._type === "call" && activity?.duration && (
                            <span style={{ 
                              fontSize: '12px', 
                              padding: '4px 8px', 
                              backgroundColor: '#f3f4f6', 
                              color: '#374151', 
                              borderRadius: '4px',
                              fontWeight: '500'
                            }}>
                              {Display.FieldValue(activity, 'duration', model.fields)}
                            </span>
                          )}
                        </div>
                        <div style={{ fontSize: '14px', color: '#4b5563', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <FaCalendar size={14} />
                          {Util.serverStringToDisplayDateTime(activity.date_time)}
                        </div>
                      </div>
                      
                    </div>

                    {activity.feedback && activity.feedback !== "—" ? (
                      <div style={{ marginTop: '8px' }}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                          <FaCommentAlt size={14} style={{ color: '#9ca3af', marginTop: '2px', flexShrink: 0 }} />
                          <div style={{ fontSize: '14px', color: '#374151' }}>
                            <span style={{ fontWeight: '500' }}>Feedback: </span>
                            {Display.FieldValue(activity, 'feedback', model.fields)}
                          </div>
                        </div>
                        {activity.comment && activity.comment !== "—" && (
                          <div style={{ marginLeft: '24px', paddingLeft: '12px', borderLeft: '2px solid #e5e7eb', marginTop: '4px' }}>
                            <p style={{ fontSize: '12px', color: '#6b7280', fontStyle: 'italic', margin: 0 }}>
                              {Display.FieldValue(activity, 'comment', model.fields)}
                            </p>
                          </div>
                        )}
                      </div>
                    ) : null}
                  </Card>
                </div>
              })}
            </div>
          </div>
        </div>
      </ApiUiController>
    )
  }
}

export default TimelineTab